import { useReducer } from 'react';

import { assertUnreachable } from '../../../util/assertUnreachable';

export enum DialogAction {
  BeginOpen = 'BeginOpen',
  FinishOpen = 'FinishOpen',
  BeginClose = 'BeginClose',
  FinishClose = 'FinishClose',
}

export enum DialogState {
  CLOSED = 'Closed',
  CLOSING = 'Closing',
  OPENING = 'Opening',
  OPEN = 'Open',
}

function dialogReducer(state: DialogState, action: DialogAction) {
  switch (action) {
    case DialogAction.BeginOpen: {
      if ([DialogState.CLOSING, DialogState.CLOSED].includes(state)) {
        return DialogState.OPENING;
      }
      return state;
    }

    case DialogAction.BeginClose: {
      if ([DialogState.OPEN, DialogState.OPENING].includes(state)) {
        return DialogState.CLOSING;
      } else {
        return state;
      }
    }

    case DialogAction.FinishClose: {
      if (state === DialogState.CLOSING) {
        return DialogState.CLOSED;
      } else {
        return state;
      }
    }

    case DialogAction.FinishOpen: {
      if (state === DialogState.OPENING) {
        return DialogState.OPEN;
      } else {
        return state;
      }
    }
    default: {
      return assertUnreachable(action);
    }
  }
}

export function useDialogReducer(initialState: DialogState) {
  return useReducer(dialogReducer, initialState);
}
